import { RenderPass } from "@/core/pipeline/render-pass"
import { OutputColorSpace, RenderColorSpace } from "@/core/types"
import { Texture } from "@/core/backends/webgl/texture"

export interface YUVOutput {
	y: Texture
	u: Texture
	v: Texture
}

export class YUVOutputPass extends RenderPass {
	render(
		input: Texture,
		output?: YUVOutput,
		options?: {
			outputColorSpace?: RenderColorSpace
		},
	) {
		const { renderer } = this

		// Output color space
		let outputColorSpace: OutputColorSpace

		switch (options?.outputColorSpace) {
			case "srgb":
				outputColorSpace = OutputColorSpace.sRGB
				break
			default:
				outputColorSpace = OutputColorSpace.displayP3
				break
		}

		// Y plane

		renderer.setRenderTarget(output?.y)
		input.bind(0)

		renderer.shaders.yuvOutput.render({
			inputTexture: 0,
			outputColorSpace,
			plane: 0,
		})

		// U and V planes (MRT single pass)

		if (output?.u && output?.v) {
			renderer.setRenderTarget(output.u, [output.v])
			input.bind(0)

			renderer.shaders.yuvOutputUV.render({
				inputTexture: 0,
				outputColorSpace,
			})

			// Detach MRT textures and reset state to ensure V texture write completes
			const gl = renderer.backend.gl
			gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0)
			gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT1, gl.TEXTURE_2D, null, 0)
			gl.drawBuffers([gl.COLOR_ATTACHMENT0])
		}
	}

	dispose() {
		return
	}
}
